import React, { useContext, useState } from 'react';
import { sectionedPanelStyle } from '../../../../styles';
import { Spacer } from '@adserve/adserve-react-components';
import { SystemSettingsContext } from '../../../../contexts/SystemSettingsContext';
import { GetCampaignPerformancePdfNew } from '../../../../services/CampaignsDataService';
import { AsButton, RadioButton, useModal } from '@adserve/adserve-react-components';
import OverAllPerformance from '../BreakdownFigures/OverAllPerformance';

const FinancialBreakdown = ({
    campaign,
    order = {},
    id = 'FinancialBreakdown',
    performanceStats = {},
    dayPartTable,
    showDetail,
    deliveryTable
}) => {
    const { formatCurrency, formatNumber } = useContext(SystemSettingsContext);
    const { addMessage } = useModal();
    const radioTextStyle = {
        marginLeft: 5.5,
        marginRight: 8,
        fontSize: 15
    };
    const titleStyle = {
        fontFamily: 'Roboto',
        fontSize: 17,
        color: '#414141',
        textDecoration: 'none solid rgb(65, 65, 65)',
        fontWeight: 'bold'
    };

    const statisticStyleGreyLong = {
        width: 180, //'77%',
        height: 25,
        padding: '8px 10px 0px 10px',
        border: '1px solid #dfdfdf',
        backgroundColor: '#f7f7f7',
        fontFamily: 'Roboto',
        fontSize: 14,
        color: '#414141',
        textDecoration: 'none solid rgb(65, 65, 65)',
        marginTop: -1
    };

    const statisticStyleGreyShort = {
        width: 70, //'23%',
        height: 25,
        padding: '8px 10px 0px 10px',
        border: '1px solid #dfdfdf',
        backgroundColor: '#f7f7f7',
        fontFamily: 'Roboto',
        fontSize: 14,
        color: '#414141',
        textDecoration: 'none solid rgb(65, 65, 65)',
        marginLeft: -1,
        marginTop: -1
    };

    const statisticStyleWhiteLong = {
        width: 180, //'77%',
        height: 25,
        padding: '8px 10px 0px 10px',
        border: '1px solid #dfdfdf',
        backgroundColor: '#ffffff',
        fontFamily: 'Roboto',
        fontSize: 14,
        color: '#414141',
        textDecoration: 'none solid rgb(65, 65, 65)',
        marginTop: -1
    };

    const statisticStyleWhiteShort = {
        width: 70, //'23%',
        height: 25,
        padding: '8px 10px 0px 10px',
        border: '1px solid #dfdfdf',
        backgroundColor: '#ffffff',
        fontFamily: 'Roboto',
        fontSize: 14,
        color: '#414141',
        textDecoration: 'none solid rgb(65, 65, 65)',
        marginLeft: -1,
        marginTop: -1
    };

    const CustomCell = ({ value, style, align = 'right' }) => (
        <div align={align} style={style}>
            <span> {value} </span>
        </div>
    );
    const roundedImpacts = (v) => {
        let decimals = 0;
        switch (displayField) {
            case 'OTH':
                decimals = 1;
                break;
            case 'Budget':
                decimals = 2;
                break;
        }

        return formatNumber(v, { maximumFractionDigits: decimals });
    };
    const decimalImpacts = (v) => {
        return formatNumber(v, { maximumFractionDigits: 1 });
    };
    const [displayField, setDisplayField] = useState('Impacts');
    const value1 = (entity) => {
        let fld = 'bookedImpacts';
        switch (displayField) {
            case 'Impacts':
                fld = 'bookedImpacts';
                break;
            case 'Reach':
                fld = 'bookedReach';
                break;
            case 'Spots':
                fld = 'bookedSpots';
                break;
            case 'OTH':
                fld = 'bookedOTH';
                break;
            case 'Budget':
                fld = 'bookedBudget';
                break;
        }
        return entity[fld];
    };
    const value2 = (entity) => {
        let fld = 'bookedImpacts';
        switch (displayField) {
            case 'Impacts':
                fld = 'deliveredImpacts';
                break;
            case 'Reach':
                fld = 'deliveredReach';
                break;
            case 'Spots':
                fld = 'deliveredSpots';
                break;
            case 'OTH':
                fld = 'deliveredOTH';
                break;
            case 'Budget':
                fld = 'deliveredBudget';
                break;
        }
        return entity[fld];
    };
    const value3 = (entity) => {
        let fld = 'bookedImpacts';
        switch (displayField) {
            case 'Impacts':
                fld = 'scheduledImpacts';
                break;
            case 'Reach':
                fld = 'scheduledReach';
                break;
            case 'Spots':
                fld = 'scheduledSpots';
                break;
            case 'OTH':
                fld = 'scheduledOTH';
                break;
            case 'Budget':
                fld = 'scheduledBudget';
                break;
        }
        return entity[fld];
    };
    const handleExport = async () => {
        const html = [];
        html.push(`
        <div id='deliveryTable' >
        <table border=1 style='border-collapse:collapse'>
            <thead>
            <tr>
                <th>${window.translate('')}</th>
                <th>${window.translate('Booked')}</th>
                <th>${window.translate('Delivered')}</th>
                <th>${window.translate('Scheduled')}</th>
                <th>${window.translate('Tracking')}</th>
            </tr>
        </thead>`);
        deliveryTable?.stationRows?.map((a, b) => {
            html.push(
                `<tr>
                <td align='left'>${a.name}</td>
                <td>${roundedImpacts(value1(a))}</td>
                <td>${roundedImpacts(value2(a))}</td>
                <td>${roundedImpacts(value3(a))}</td>
                <td>${roundedImpacts((value3(a) / value1(a)) * 100) + ' %'}</td>
                </tr>`
            );
        });
        html.push(`
        <tr>
                <td align='left'>${'Total'}</td>
                <td>${roundedImpacts(value1(deliveryTable))}</td>
                <td>${roundedImpacts(value2(deliveryTable))}</td>
                <td>${roundedImpacts(value3(deliveryTable))}</td>
                <td>${roundedImpacts((value3(deliveryTable) / value1(deliveryTable)) * 100) + ' %'}</td>
                </tr>`);
        html.push('</table></div>');
        const msg = html.join('');
        try {
            GetCampaignPerformancePdfNew('<!DOCTYPE html><html><body>' + msg + '</body></html>').then((base64Pdf) => {
                const newTab = window.open();
                newTab.document.title = campaign.name;
                newTab.document.body.style.margin = '0';
                newTab.document.body.innerHTML = `<iframe
                    style="width: 100%;height: 100%;box-sizing: border-box;"
                    src="data:application/pdf;base64,${base64Pdf}"></iframe>`;
            });
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Failed to open quote pdf${campaign.id}.\n${err?.message || err}`);
            addMessage({
                message: `An error occured while attempting to open Quote ${campaign.name}.`,
                buttons: [
                    {
                        text: window.translate('Ok'),
                        callback: null
                    }
                ]
            });
        }
    };
    return (
        <div
            id={id}
            style={{
                ...sectionedPanelStyle,
                padding: '6px 19px',
                height: 376,
                boxSizing: 'border-box',
                fontSize: 10,
                width: '100%'
            }}
        >
            {showDetail ? (
                <>
                    {/* ASSP-7703 clarify tabulation */}
                    <div style={{ ...titleStyle, margin: '12px 0' }}>
                        {window.translate('Performance by Station - Selected Stations')}
                    </div>
                    <OverAllPerformance data={deliveryTable} />
                </>
            ) : (
                <>
                    <div style={{ ...titleStyle, margin: '12px 0 6px' }}>
                        {window.translate('Performance by Station - All Stations')}
                    </div>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: 12
                    }}>
                        <div style={{
                            width: 380,
                            display: 'flex',
                            justifyContent: 'space-between'
                        }}>
                            <div
                                onClick={() => setDisplayField('Impacts')}
                                style={{ display: 'flex', cursor: 'pointer' }}
                            >
                                <RadioButton width={16} height={16} value={displayField === 'Impacts'} />
                                <span style={radioTextStyle}> {window.translate('Impacts')} </span>
                            </div>
                            <div
                                onClick={() => setDisplayField('Reach')}
                                style={{ display: 'flex', cursor: 'pointer' }}
                            >
                                <RadioButton width={16} height={16} value={displayField === 'Reach'} />
                                <span style={radioTextStyle}> {window.translate('Reach')} </span>
                            </div>
                            <div
                                onClick={() => setDisplayField('Spots')}
                                style={{ display: 'flex', cursor: 'pointer' }}
                            >
                                <RadioButton width={16} height={16} value={displayField === 'Spots'} />
                                <span style={radioTextStyle}> {window.translate('Spots')} </span>
                            </div>
                            <div onClick={() => setDisplayField('OTH')} style={{ display: 'flex', cursor: 'pointer' }}>
                                <RadioButton width={16} height={16} value={displayField === 'OTH'} />
                                <span style={radioTextStyle}> {window.translate('OTH')} </span>
                            </div>
                            <div
                                onClick={() => setDisplayField('Budget')}
                                style={{ display: 'flex', cursor: 'pointer' }}
                            >
                                <RadioButton width={16} height={16} value={displayField === 'Budget'} />
                                <span style={radioTextStyle}> {window.translate('Budget')} </span>
                            </div>
                        </div>
                        <AsButton
                            id='export-btn'
                            handleClick={handleExport}
                            disabled={false}
                            style={{
                                fontWeight: 'bold',
                                fontSize: 15,
                                height: 36,
                                width: 85
                            }}
                        >
                            {window.translate('Export')}
                        </AsButton>
                    </div>
                    <div id='deliveryTable' style={{ overflow: 'auto', height: 239 }}>
                        <div style={{ display: 'flex', width: '100%', marginTop: 0, position: 'sticky', top: 0 }}>
                            <CustomCell
                              style={{ ...statisticStyleWhiteLong, marginTop: 0 }}
                              align={'left'}
                              value={window.translate('')}
                            />
                            <CustomCell
                              style={{ ...statisticStyleWhiteShort, marginTop: 0 }}
                              value={window.translate('Booked')}
                            />
                            <CustomCell
                              style={{ ...statisticStyleWhiteShort, marginTop: 0 }}
                              value={window.translate('Delivered')}
                            />
                            <CustomCell
                              style={{ ...statisticStyleWhiteShort, marginTop: 0 }}
                              value={window.translate('Scheduled')} 
                            />
                            <CustomCell
                              style={{ ...statisticStyleWhiteShort, marginTop: 0 }}
                              value={window.translate('Tracking')}
                            />
                        </div>
                        {deliveryTable?.stationRows?.map((a, b) => {
                            const long = b % 2 ? statisticStyleWhiteLong : statisticStyleGreyLong;
                            const short = b % 2 ? statisticStyleWhiteShort : statisticStyleGreyShort;
                            return (
                                <div style={{ display: 'flex', width: '100%' }}>
                                    <CustomCell style={long} align={'left'} value={a.name} />
                                    <CustomCell style={short} value={roundedImpacts(value1(a))} />
                                    <CustomCell style={short} value={roundedImpacts(value2(a))} />
                                    <CustomCell style={short} value={roundedImpacts(value3(a))} />
                                    <CustomCell 
                                        style={short}
                                        value={roundedImpacts((value3(a) / value1(a)) * 100) + ' %'}
                                    />
                                </div>
                            );
                        })}
                        <div style={{ display: 'flex', width: '100%' }}>
                            <CustomCell 
                              style={deliveryTable?.stationRows?.length % 2 ? statisticStyleWhiteLong : statisticStyleGreyLong} 
                              align={'left'} value={'Total'}
                            />
                            <CustomCell
                              style={deliveryTable?.stationRows?.length % 2 ? statisticStyleWhiteShort : statisticStyleGreyShort}
                              value={roundedImpacts(value1(deliveryTable))}
                            />
                            <CustomCell
                              style={deliveryTable?.stationRows?.length % 2 ? statisticStyleWhiteShort : statisticStyleGreyShort}
                              value={roundedImpacts(value2(deliveryTable))}
                            />
                            <CustomCell
                              style={deliveryTable?.stationRows?.length % 2 ? statisticStyleWhiteShort : statisticStyleGreyShort}
                              value={roundedImpacts(value3(deliveryTable))}
                            />
                            <CustomCell
                              style={deliveryTable?.stationRows?.length % 2 ? statisticStyleWhiteShort : statisticStyleGreyShort}
                              value={roundedImpacts((value3(deliveryTable) / value1(deliveryTable)) * 100) + ' %'}
                            />
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default FinancialBreakdown;
